import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { FlexDirection } from 'components.layout/flex-blocks.js';
import { formatDate, TIME_FORMATS } from 'utilities/date.js';

export type SunSetSunRiseProps = {
  direction?: FlexDirection;
  classes?: string;
  sunrise?: string; // @TODO Type these to be ISO 8601
  sunset?: string;
};

export const SunRiseSunset = ({ sunrise, sunset, direction = FlexDirection.row, classes }: SunSetSunRiseProps) => {
  if (sunrise && sunset) {
    return (
      <div className={classNames(`u-flex u-flex${direction}`, classes)}>
        <IconWithText icon="sun-rise" classes="IconWithText--vCenter IconWithText--small IconWithText--inline u-pR-sm">
          <p className="small u-mT-0 u-mB-0">
            <span className="h4">sunrise</span> {formatDate(sunrise, TIME_FORMATS.HourMin)}
          </p>
        </IconWithText>
        <IconWithText icon="sun-set" classes="IconWithText--vCenter IconWithText--small IconWithText--inline">
          <p className="small u-mT-0 u-mB-0">
            <span className="h4">sunset</span> {formatDate(sunset, TIME_FORMATS.HourMin)}
          </p>
        </IconWithText>
      </div>
    );
  }
  return null;
};
